import { Reveal } from '../components/motion';
import SEO from '../components/SEO';
import { SectionTag, ArrowBtn, PageHero } from '../components/bits';
import { useLead } from '../components/LeadModal';
import { useContent } from '../lib/content';
import { MEMBERSHIP_ADVANTAGES, IMAGES } from '../content/data';

const COMPOUND = [
  'More learners → more capability.',
  'More enterprise requirements → more real projects.',
  'More projects → more evidence.',
  'More evidence → better matching.',
  'Better matching → more opportunity.',
  'More opportunity → a stronger ecosystem.',
];

export default function Membership() {
  const { open } = useLead();
  const { ctList } = useContent();
  return (
    <div data-testid="membership-page">
    <SEO title="Enterprise Membership" description="One relationship. Seven strategic advantages for enterprises." />
      <PageHero
        ck="membership"
        dark
        tag="Enterprise Membership"
        lines={<>One Relationship. <span className="font-serif italic font-normal text-gold">Seven Strategic Advantages.</span></>}
        intro="An institutional relationship designed to connect enterprise requirements with talent, research, technology, marketing and strategic capabilities."
      >
        <ArrowBtn onClick={() => open('Enterprise Membership')} variant="gold" testId="membership-cta-become">Become a DITEC Member</ArrowBtn>
      </PageHero>

      <section className="bg-paper py-20 sm:py-28">
        <div className="wrap">
          <SectionTag>01 — The Seven Advantages</SectionTag>
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {ctList('membership.advantages', MEMBERSHIP_ADVANTAGES).map((m, i) => (
              <Reveal key={m.n} delay={i * 0.05} className={`rounded-3xl p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 ${i === 6 ? 'bg-electric text-white sm:col-span-2 lg:col-span-1 hover:shadow-xl hover:shadow-electric/30' : 'border border-navy/10 bg-white hover:shadow-xl hover:shadow-navy/10'}`}>
                <span className={`font-mono text-3xl font-semibold ${i === 6 ? 'text-gold' : 'text-electric/20'}`}>{m.n}</span>
                <h3 className="mt-4 text-lg font-semibold leading-snug tracking-tight">{m.title}</h3>
                <p className={`mt-2.5 text-sm leading-relaxed ${i === 6 ? 'text-white/80' : 'text-navy/65'}`}>{m.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-28">
        <div className="wrap grid items-center gap-12 lg:grid-cols-2">
          <div>
            <SectionTag>02 — Why Membership Compounds</SectionTag>
            <div className="mt-10 space-y-3">
              {COMPOUND.map((c, i) => (
                <Reveal key={c} delay={i * 0.05} className="flex touch-target items-center gap-4 rounded-2xl border border-navy/10 bg-paper px-6 py-4">
                  <span className="font-mono text-xs text-electric">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-sm font-semibold tracking-tight sm:text-base">{c}</span>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2} className="mt-10"><ArrowBtn onClick={() => open('Enterprise Membership')} variant="primary" testId="membership-cta-bottom">Become a DITEC Member</ArrowBtn></Reveal>
          </div>
          <Reveal delay={0.1}>
            <div className="overflow-hidden rounded-3xl border border-navy/10 shadow-2xl shadow-navy/15">
              <img src={IMAGES.glass} alt="Geometric glass facade" className="aspect-[4/5] w-full object-cover sm:aspect-[4/4]" loading="lazy" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
